
// Find the unanswered questions from an assessment

export default function getUnansweredQuestions(questions, answers) {
  return Object.values(questions).filter((question) => {
    const answer = answers[question.id];
    const hasNoParts = !question.parts || question.parts.length === 0;
    return !answer // answer object is blank
      || (!hasNoParts && !answer.parts) // answer parts are blank
      || (hasNoParts && !answer.observations); // question has no parts and answer has no observations
  });
}



// WEBPACK FOOTER //
// ./src/utils/unansweredQuestions.js